<template>
  <div>
    <paginate 
      v-if="sezenden.length" 
      ref="paginator" 
      name="sezendenPaginate" 
      :list="sezenden" :per="6" 
      :refreshCurrentPage="true">
      <!-- item -->
      <div class="item" v-for="(item,i ) in paginated('sezendenPaginate')" :key="i">
        <div class="item-date">
          <div class="date-circle">
            <div class="day">{{ new Date(item.Date).getDate() }}</div>
            <div class="month">{{ new Date(item.Date).getMonth()+1 | month(lng) }}</div>
            <div class="year">{{ new Date(item.Date).getFullYear() }}</div>
          </div> 
        </div>
        <div class="item-text">
          <h1 class="title">{{ item.Key }}</h1>
          <div class="text" v-html="crop(item.Body,140)"></div>
          <router-link :to="'sezenden/'+item.ID" class="link-to">{{t.info }}</router-link>
        </div>
      </div>
      <!--  /end item -->
    </paginate>
    <paginate-links 
      v-if="sezenden.length" 
      for="sezendenPaginate" 
      :hide-single-page="true" 
      :limit="3" 
      :show-step-links="true"></paginate-links>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      paginate: ['sezendenPaginate']
    };
  },
  computed: {
    ...mapGetters(['t', 'lng', 'sezenden'])
  },
  methods: {
    crop(value, limit) {
      // if null
      const val = value ? value : '';
      const txt = document.createElement('textarea');
      txt.innerHTML = val.replace(/(<([^>]+)>)/gi, '');
      return txt.value.length > 140
        ? txt.value.substr(0, limit) + ' ...'
        : txt.value;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../styles/colors';
@import '../../styles/announcements_partner';
</style>
